export const option = {
  namespaced: true,
  state: {
    hasFooter: true,
  },
  getters: {
    getHasFooter(state) {
      return state.hasFooter
    },
  },
  // Sync process only
  mutations: {
    changeHasFooter(state, isOn) {
      state.hasFooter = isOn
    },
  },
  // Async process, External API linkage
  actions: {},
}
